<div class="content">
    <!-- <p>Can't create new vendor!</p> -->
    <h3>
        Your login credentials has sent to your mail. Please check e-mail.
    </h3>
    <button mat-raised-button class="button" (click)="onNoClick()">Ok</button>
</div>